export default "__VITE_ASSET__CXoEkK$z__"